<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="1100px"
      :fullscreen="fullscreen"
      :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">评审结果</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-form v-model="formValid" ref="formRef">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-data-table
                    class="dense"
                    :headers="xHeader"
                    :items=markItems
                >
                  <template v-slot:items="{item, index}">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item['name'] }}</td>
                    <td v-for="(it,i) in others">{{ item[`score_${i}`] }}</td>
                  </template>
                  <!--                  <template v-slot:headers="{ headers }">-->
                  <!--                    <tr>-->
                  <!--                      <th-->
                  <!--                          v-for="header in headers"-->
                  <!--                          :key="header.text"-->
                  <!--                      >-->
                  <!--                        {{ header.text }}-->
                  <!--                      </th>-->
                  <!--                    </tr>-->
                  <!--                  </template>-->

                  <!--                  <template v-slot:items="{ markItems }">-->
                  <!--                    <tr>-->
                  <!--                      <th-->
                  <!--                          v-for="item in items"-->
                  <!--                          :key="item.value"-->
                  <!--                      >-->
                  <!--                         item.value-->
                  <!--                      </th>-->
                  <!--                    </tr>-->
                  <!--                  </template>-->

                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn flat color="primary" @click.native="onReturn">返回</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const baseUri = '/api/proj/review-mark'
const baseURI = '/api/proj/review-expert';
export default {
  name: "ReviewResult",
  props: ['mark', 'reviewId', 'decproj'],
  data() {
    return {

      formValid: false,
      visible: false,
      fullscreen: false,

      items: [],
      expertItems: [],

      temp: 'name',


      markItems: [],

      markItemst: {
        "name": '测试项目'
      },

      headers: [
        {text: '#', sortable: false, value: 'rank', width: 18},
        {text: '项目名称', value: 'name', sortable: true},
      ],
      others: []
    }
  },

  computed: {
    xHeader() {
      return [].concat(this.headers, this.others)
    }
  },

  watch: {
    mark(mark) {
      this.visible = mark
    },

    reviewId(reviewId) {
      let tt = []
      let expert = []
      this.axios.get(`${baseURI}?reviewId=${reviewId.dbid}`)
          .then(
              rspExp => {
                this.expertItems = rspExp.data.items
                if(this.expertItems.length > 0)
                {
                  for (let j = 0; j < this.expertItems.length; j++) {
                    expert.push(this.expertItems[j].expertId)
                  }
                }
                tt = expert
                if (tt.length > 0) {
                  this.axios.get(`${baseUri}/${reviewId.dbid}/${tt}`)
                      .then(
                          rsp => {
                            this.others = rsp.data.items[0]['scores'].map((s, i) => {
                              return {text: s['exptName'], value: `score_${i}`, sortable: false}
                            })
                            this.markItems = rsp.data.items.map(r => {
                              r["scores"].forEach((it, i) => {
                                r[`score_${i}`] = it.score
                              })
                              return r
                            })
                          }
                      )
                }
                /*const data = [
                  {
                    "name": "test project",
                    scores: [{"exptName": "Expt 1", "score": 80}, {"exptName": "Expt 2", "score": 81}, {"exptName": "Expt 2", "score": 81}]
                  }, // 1
                  {
                    "name": "test project 22",
                    scores: [{"exptName": "Expt 1", "score": 70}, {"exptName": "Expt 2", "score": 91}, {"exptName": "Expt 2", "score": 81}]
                  } // 1
                ]
                vm.others = data[0]['scores'].map((s, i) => {
                  return {text: s['exptName'], value: `score_${i}`, sortable: false}
                })

                vm.markItems = data.map(r => {
                  r.scores.forEach((it, i) => {
                    r[`score_${i}`] = it.score
                  })
                  return r
                })

                return;



                if(this.expertItems.length > 0)
                {
                  for (let j = 0; j < this.expertItems.length; j++) {
                    expert.push(this.expertItems[j].expertId)
                    this.headers.push({text: this.expertItems[j].expertId, value: this.expertItems[j].expertId})
                    vm.addColumn(this.expertItems[j].expertId)
                  }
                }

                window.console.log("动态添加属性测试！")

                window.console.log(this.headers)
                window.console.log(this.markItemst)
                this.markItems.push(this.markItemst)
                window.console.log(this.markItems)
                //tt暂存本申报所有专家ID，并传入servlet，但目前暂未使用该参数
                tt = expert
                this.axios.get(`${baseUri}/${reviewId.dbid}/${tt}`)
                    .then(
                        rsp => {
                          window.console.log("根据reviewid获取申报评审结果！")
                          this.items = rsp.data.items
                          window.console.log(this.items)
                          window.console.log(this.decproj)

                          let ttotal = 0
                          for (let m = 0; m < this.decproj.length; m++) {
                            this.markItems.push({'name':this.decproj[m].reviewProj.name})
                            for (let n = 0; n < expert.length; n++) {
                              for (let i = 0; i < this.items.length; i++) {
                                if (this.decproj[m].projId === this.items[i].projectId && expert[n] === this.items[i].expertId)
                                  ttotal = ttotal + this.items[i].mark
                              }
                              vm.addColumn(expert[n],ttotal)
                              //this.markItems.push({name:this.decproj[m].reviewProj.name,value:ttotal})
                              ttotal = 0
                            }
                          }

                          window.console.log("this.markItems")
                          window.console.log(this.markItems)


                        }
                    )
                */
              }
          )
    },
  },

  methods: {
    addColumn(id) {
      this.$set(this.markItemst, id, '100')
    },

    onReturn() {
      this.visible = false
      this.$emit('ok', false);
    }
  }

}
</script>

<style scoped>

</style>